const childrenLoaded = require('@alexspirgel/children-loaded');

class ComponentEventsFeed extends HTMLDivElement {

    constructor() {
        super();
    }

    async connectedCallback() {
        await childrenLoaded(this);
        this.initialize();
    }

    async initialize() {
        if (this.initialized) {
            return;
        }
        this.initialized = true;
        const itemsContainerElement = this.querySelector('.component-events-feed__items');
        const itemTemplateElement = this.querySelector('.component-events-feed__item-template');
        const noResultsElement = this.querySelector('.component-events-feed__no-results'); // Target the no-results container
        
        // Safety Guard: Exit if essential DOM elements are missing
        if (!itemsContainerElement || !itemTemplateElement) {
            this.initialized = false;
            return;
        }

        const parser = new RSSParser({
            customFields: {
                item: [
                    ['media:content', 'mediaContent', { keepArray: false }],
                    ['image', 'itemImage'],
                    ['daterange', 'dateRange'],
                    ['enddate', 'endDate'],
                ]
            }
        });
        const feedURL = `/esd_request_proxy?esd-proxy-uri=${encodeURIComponent(this.getAttribute('data-feed-url'))}`;
        const feed = await parser.parseURL(feedURL);

        // --- NO RESULTS CHECK ---
        // If the feed is empty or the items array doesn't exist
        if (!feed || !feed.items || feed.items.length === 0) {
            if (noResultsElement) {
                noResultsElement.style.display = 'block'; // Reveal the "No results" markup
            }
            return; // Halt execution early
        } else {
            if (noResultsElement) {
                noResultsElement.style.display = 'none'; // Ensure it's hidden if there is data
            }
        }

        // Set display template & set which fields should be populated
        const template = this.getAttribute('data-display-template');
        let arr = [];

        switch(template) {
            case "card_with_image":
            case "list_with_image":
                arr = ["image", "title", "description", "date"]; 
                break;
            case "card_without_image":
            case "list_without_image":
            case "media_clips":
                arr = ["title", "description", "date"]; 
                break;
            case "bullet_list":
                arr = ["title", "date"];
                break;
            default:
                arr = [];
        }

        // Check if max items to display is greater than # of items in XML feed
        const maxItemsAttr = this.getAttribute('data-max-items');
        // Convert to an integer, or fallback to the total feed length if blank
        const maxItems = maxItemsAttr ? parseInt(maxItemsAttr, 10) : feed.items.length;
        
        // Run the loop, ensuring it stops if the feed runs out of items early
        for (let i = 0; i < maxItems && i < feed.items.length; i++) {
            if (!(itemTemplateElement instanceof HTMLTemplateElement)) {
                console.error('Template element not found or invalid');
                return;
            }
            const item = feed.items[i];
            if (!item) {
                break;
            }

            const itemElement = itemTemplateElement.content.cloneNode(true);
            
            const itemLinkElement = itemElement.querySelector('.component-events-feed__item-link');
            if (itemLinkElement && item['link']) {
                itemLinkElement.setAttribute('href', item['link']);
            }
            
            if (arr.includes("title")) {
                const itemTitleElement = itemElement.querySelector('.component-events-feed__item-title');
                if (itemTitleElement) {
                    itemTitleElement.textContent = item['title'];
                }
            }
            
            if (arr.includes("date")) {
                const itemRangeElement = itemElement.querySelector('.component-events-feed__item-range');
                const itemDayElement = itemElement.querySelector('.component-events-feed__item-day');                    
                const itemMonthElement = itemElement.querySelector('.component-events-feed__item-month');

                if (item['dateRange']) {
                    itemRangeElement.textContent = "Runs: " + item['dateRange'];
                    const today = new Date();

                    const day = today.getDate();
                    const month = today.toLocaleString('default', { month: 'short' });

                    const pubDate = new Date(item['isoDate']);

                    const endDate = new Date(item['endDate']);

                    if(Date.parse(pubDate)-Date.parse(new Date())>0){
                        // console.log('date is in future') ;
                        if (itemDayElement && item['isoDate']) {
                            let itemDay = new Date(item['isoDate']);
                            itemDay = itemDay.toLocaleDateString('en-US', {day: 'numeric'});
                            itemDayElement.textContent = itemDay;
                        }
                        if (itemMonthElement && item['isoDate']) {
                            let itemMonth = new Date(item['isoDate']);
                            itemMonth = itemMonth.toLocaleDateString('en-US', {month: 'short'});
                            itemMonthElement.textContent = itemMonth;
                        }
                    }
                    if( Date.parse(endDate)-Date.parse(new Date())>0) {
                        if(Date.parse(pubDate)-Date.parse(new Date())<0){
                            // console.log('Date is in past');
                            itemDayElement.textContent = day;
                            itemMonthElement.textContent = month;
                        }
                    }else{
                        if (itemDayElement && item['endDate']) {
                            let itemDay = new Date(item['endDate']);
                            itemDay = itemDay.toLocaleDateString('en-US', {day: 'numeric'});
                            itemDayElement.textContent = itemDay;
                        }
                        if (itemMonthElement && item['endDate']) {
                            let itemMonth = new Date(item['endDate']);
                            itemMonth = itemMonth.toLocaleDateString('en-US', {month: 'short'});
                            itemMonthElement.textContent = itemMonth;
                        }
                    }


                } else {       
                    itemRangeElement.textContent = "";         
                    if (itemDayElement && item['isoDate']) {
                        let itemDay = new Date(item['isoDate']);
                        itemDay = itemDay.toLocaleDateString('en-US', {day: 'numeric'});
                        itemDayElement.textContent = itemDay;
                    }
                    if (itemMonthElement && item['isoDate']) {
                        let itemMonth = new Date(item['isoDate']);
                        itemMonth = itemMonth.toLocaleDateString('en-US', {month: 'short'});
                        itemMonthElement.textContent = itemMonth;
                    }
                }
            }
            
            if (arr.includes("image")) {
                const itemImageElement = itemElement.querySelector(
                    '.component-events-feed__item-image'
                );
                
                if (itemImageElement) {
                    let imageUrl = null;

                    if (item.mediaContent && item.mediaContent['$'] && item.mediaContent['$'].url) {
                        imageUrl = item.mediaContent['$'].url;
                    }

                    if (!imageUrl && item.enclosure && item.enclosure.url) {
                        imageUrl = item.enclosure.url;
                    }

                    if (!imageUrl && item.itemImage) {
                        imageUrl = typeof item.itemImage === 'string' ? item.itemImage : item.itemImage.url || item.itemImage['$']?.url;
                    }

                    if (!imageUrl) {
                        const content = item.content || item.contentSnippet || '';
                        if (content.includes('<img')) {
                            const tempDiv = document.createElement('div');
                            tempDiv.innerHTML = content;
                            imageUrl = tempDiv.querySelector('img')?.src;
                        } 
                    } 

                    // If an image URL was found anywhere in the hierarchy, apply it
                    if (imageUrl) {
                        itemImageElement.src = imageUrl;
                    }
                }
            }
            
            itemsContainerElement.appendChild(itemElement);
        }
    }
}

customElements.define('component-events-feed', ComponentEventsFeed, {extends: 'div'});